import { InputLeftAddon, Input } from "@chakra-ui/react";

import { TypeInBox } from "../style";

export const SentenceBox = ({ handleSentenceChange }) => {
  return (
    <TypeInBox
      width={{ base: "100%", md: "466px", lg: "810px" }}
      mb={{ base: "72px", md: "96px", lg: "136px" }}
      borderRadius={{ base: "2px", md: "8px", lg: "8px" }}
    >
      <InputLeftAddon
        width={{ base: "75px", md: "98px", lg: "142px" }}
        height={{ base: "40px", md: "52px", lg: "60px" }}
        justifyContent="center"
        px="0"
        children="Sentence :"
        fontSize={{ base: "12px", md: "14px", lg: "16px" }}
        fontWeight="600"
        bg="#fff"
      />
      <Input
        onChange={(e) => handleSentenceChange(e)}
        // maxlength="50"
        height={{ base: "40px", md: "52px", lg: "60px" }}
        fontSize={{ base: "14px", md: "16px", lg: "18px" }}
        placeholder="Type Something"
      />
    </TypeInBox>
  );
};
